export const engagementGeofencesData = "/engagement/geofences_data(/:location_set_id)";
